import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';

import { navRouteTypes } from '../../../types/nav';
import { userTypes } from '../../../types/user';

import { getUserData } from '../../../user/selectors';

import LargeScreenLink from './LargeScreenLink';
import { Invoices, TransactionReports } from '../../../orders';

import { isViewOnly } from '../../../util/rolePermissions';

export const LargeScreenList = ({ match, routes, isOrders, canAccessInvoices, user }) =>
  routes.length && routes.some(route => route.nav !== false) ? (
    <ul className='navigation__secondary_wrapper border d-sm-h d-lg-b pb4-md pt4-md prl6-md'>
      {routes.map(route => (
        <Fragment key={`largeScreenLink-${route.path}`}>
          {route.nav !== false && <LargeScreenLink route={route} match={match} />}
          {route.routes && (
            <span className='navigation__secondary_subRoutes border-bottom mb2-sm pb2-sm'>
              {route.routes
                .filter(subRoute => subRoute.nav !== false)
                .map(subRoute => (
                  <LargeScreenLink key={`largeScreenLink__subRoute-${subRoute.path}`} route={subRoute} match={match} />
                ))}
            </span>
          )}
        </Fragment>
      ))}
      {isOrders && canAccessInvoices && <Invoices />}
      {isOrders && !isViewOnly(user.role) && <TransactionReports />}
    </ul>
  ) : null;

LargeScreenList.defaultProps = {
  match: null,
  isOrders: false,
  user: null
};

LargeScreenList.propTypes = {
  match: ReactRouterPropTypes.match,
  routes: navRouteTypes.isRequired,
  isOrders: PropTypes.bool,
  canAccessInvoices: PropTypes.bool.isRequired,
  user: userTypes
};

const mapStateToProps = state => ({
  user: getUserData(state)
});

const connector = connect(mapStateToProps, {});

export default connector(LargeScreenList);
